import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["currentAvatar"]

  selectPreset(event) {
    // When a preset avatar is selected, clear the file input
    const fileInput = this.element.querySelector('input[type="file"]')
    if (fileInput) {
      fileInput.value = ""
    }

    // Update the current avatar preview
    const selectedAvatar = event.target.value
    if (selectedAvatar && this.hasCurrentAvatarTarget) {
      const img = this.currentAvatarTarget
      if (img.tagName === "IMG") {
        img.src = `/headshots/${selectedAvatar}`
      } else {
        // Replace placeholder with image
        const newImg = document.createElement("img")
        newImg.src = `/headshots/${selectedAvatar}`
        newImg.className = "h-16 w-16 object-cover rounded-full border-2 border-blue-500"
        newImg.dataset.avatarPickerTarget = "currentAvatar"
        this.currentAvatarTarget.replaceWith(newImg)
      }
    }
  }

  selectCustom(event) {
    // When a custom file is uploaded, clear preset selection visually
    const presetRadios = this.element.querySelectorAll('input[type="radio"][name="sales_website[preset_assistant_avatar]"]')
    presetRadios.forEach(radio => {
      radio.checked = false
    })

    // Preview the uploaded file
    const file = event.target.files[0]
    if (file && this.hasCurrentAvatarTarget) {
      const reader = new FileReader()
      reader.onload = (e) => {
        const img = this.currentAvatarTarget
        if (img.tagName === "IMG") {
          img.src = e.target.result
        } else {
          // Replace placeholder with image
          const newImg = document.createElement("img")
          newImg.src = e.target.result
          newImg.className = "h-16 w-16 object-cover rounded-full border-2 border-blue-500"
          newImg.dataset.avatarPickerTarget = "currentAvatar"
          this.currentAvatarTarget.replaceWith(newImg)
        }
      }
      reader.readAsDataURL(file)
    }
  }
}
